<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="automationId"
    [isPrimaryButtonHidden]="true" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="modalHelpIndex">
    <div class="project-access-history" [attr.data-automation-id]="automationId + '-container'">
        <res-generic-grid [gridName]="gridName" [automationId]="automationId" [columnDefs]="columnDefs"
            [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage" [pagerTemplate]="pagerWithDownloadTemplate"
            [requestInfo]="requestInfo" [responseArrayCallback]="responseArrayCallback" [gridContext]="gridContext">
        </res-generic-grid>
        <ng-template #pagerWithDownloadTemplate>
            <button type="button" [attr.data-automation-id]="automationId + '-download-button'"
                class="secondary-button icon-button" (click)="downloadGrid()" title="Download Discard Pile Log(.xlsx)">
                <i class="fa fa-download color-blue-01"></i>
            </button>
        </ng-template>

        <a download #downloadLink hidden target="_blank"></a>
    </div>
</res-base-modal>